<template>
  <AltchaGate @verified="enterApplication" />
</template>

<script>
import AltchaGate from '@/components/AltchaGate'

export default {
  name: 'AltchaVerifyPage',
  components: { AltchaGate },
  methods: {
    enterApplication() {
      this.$router.replace({ name: 'index' })
    }
  }
}
</script>
